import {
  Alert,
  Box,
  Button,
  ButtonGroup,
  Card,
  Dialog,
  Divider,
  InputLabel,
  MenuItem,
  Pagination,
  Select,
  Snackbar,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableFooter,
  TableHead,
  TableRow,
  Typography,
  useTheme,
} from "@mui/material";
import dayjs from "dayjs";
import { useEffect, useMemo, useState } from "react";
import {
  Link,
  Link as RouteLink,
  useLocation,
  useNavigate,
  useParams,
} from "react-router-dom";
import { useSelector } from "react-redux";
// import styled from "@emotion/styled";
// import CustomStatus from "../../../shared/components/customStatus/customStatus";
// import { RequestPage } from "@mui/icons-material";
// import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";
// import { blue } from "@mui/material/colors";
import "./viewRateContract.scss";
import { ReactComponent as DownloadIcon } from "../../../shared/assets/Download.svg";
import CustomSpinner from "../../../../shared/components/customSpinner/customSpinner";
import NavigateBackButton from "../../../../shared/components/customNavigateButton/customNavigateButton";
import {
  DATE_FORMAT,
  ORDER_STATUS,
  PAGES_URL,
  PO_STATUS,
} from "../../../../shared/constants/constants";
import PermissionsGate, {
  RoleBasedPermissionsGate,
} from "../../../../components/privateRoute/permissionsGate";
import {
  PLATFORM_PERMISSIONS,
  PLATFORM_ROLES,
} from "../../../../shared/models/abacConfig";
import store, { RootState } from "../../../../store/store";
import { getRateContractById } from "../../../../store/api/rateContract";
import ErrorPopup from "../../../../components/dialogBox/errorModal";

const ViewRateContract = () => {
  const params = useParams();
  const theme = useTheme();
  const navigate = useNavigate();
  const storeRateContract = useSelector(
    (state: RootState) => state.rateContract
  );

  const [openError, setOpenError] = useState<any>({
    open: false,
    message: "",
  });
  const [rateContract, setRateContract] = useState<any>();
  const [orders, setOrders] = useState<any[]>([]);
  const [page, setPage] = useState<number>(1); // Used for Pagination
  const pageLimit = 10; // Editable for number of rows per page
  const [error, setError] = useState({ open: false, message: "" });

  const RATE_CONTRACT_DATA_TYPES = {
    DATE: "date",
    NUMBER: "number",
    STRING: "string",
    LENGTH: "length",
    GROUP_NAME: "groupName",
  };

  const RATE_CONTRACT_INFO = [
    {
      label: "Number of Orders",
      id: "orders",
      type: RATE_CONTRACT_DATA_TYPES.LENGTH,
      width: { md: "25%", sm: "33%", xs: "50%" }
    },
    {
      label: "Contract Limit (₹)",
      id: "rateContractAmountLimit",
      type: RATE_CONTRACT_DATA_TYPES.NUMBER,
      width: { md: "25%", sm: "33%", xs: "50%" }
    },
    {
      label: "Validity Date",
      id: "validTillDate",
      type: RATE_CONTRACT_DATA_TYPES.DATE,
      width: { md: "25%", sm: "33%", xs: "50%" }
    },
    {
      label: "Fulfilling Party",
      id: "fulfilledByPartyId",
      type: RATE_CONTRACT_DATA_TYPES.GROUP_NAME,
      width: { md: "25%", sm: "33%", xs: "50%" }
    },
    {
      label: "Payment Terms",
      id: "paymentTerms",
      type: RATE_CONTRACT_DATA_TYPES.STRING,
      width: { md: "25%", sm: "50%", xs: "100%" }
    },
    {
      label: "Terms and Conditions",
      id: "termsAndConditions",
      type: RATE_CONTRACT_DATA_TYPES.STRING,
      width: { md: "75%", sm: "50%", xs: "100%" }
    },
  ];

  const RATE_CONTRACT_TABLE = [
    { id: "item", label: "Name", colSpan: "32%" },
    // { id: "hsnCode", label: "HSN/SAC", colSpan: "12%" },
    { id: "brandName", label: "Brand", colSpan: "15%" },
    { id: "size", label: "Specification", colSpan: "15%" },
    { id: "finalUnitPrice", label: "Unit Price(₹)", colSpan: "14%" },
    { id: "gst", label: "GST(%)", colSpan: "10%" },
    { id: "amount", label: "Amount(₹)", colSpan: "14%" },
    // { id: "itemTypeId", label: "Category", colSpan: "12%" },
  ];

  const RC_ORDERS = [
    { id: "orders", label: "Order ID", length: 20 },
    { id: "sname", label: "Seller Name", length: 20 },
    { id: "itemSize", label: "Number of Items", length: 20 },
    { id: "amount", label: "Total Amount", length: 20 },
    { id: "status", label: "Status", length: 20 },
  ];

  // useEffect(() => {console.log(rfq)}, [rfq]);
  useEffect(() => {
    store
      .dispatch(getRateContractById(params.id))
      .unwrap()
      .then((resp) => {
        setRateContract(resp.data);
        setOrders(resp?.data?.orders);
      })
      .catch(() => {});
  }, [params.id]);

  // Switch for displaying different types of data in table of rfq
  const renderSwitch = (detailRow: any) => {
    if (!rateContract) {
      return "-";
    }

    switch (detailRow.type) {
      case RATE_CONTRACT_DATA_TYPES.DATE:
        return (
          dayjs(rateContract[detailRow.id]).format(DATE_FORMAT.ISO_FORMAT) ||
          "-"
        );
      case RATE_CONTRACT_DATA_TYPES.LENGTH:
        return rateContract[detailRow.id]?.length || "-";
      case RATE_CONTRACT_DATA_TYPES.NUMBER:
        return rateContract[detailRow.id] || "-";
      case RATE_CONTRACT_DATA_TYPES.STRING:
        return rateContract[detailRow.id] || "-";
      case RATE_CONTRACT_DATA_TYPES.GROUP_NAME:
        return rateContract[detailRow.id]?.details?.groupName || "-";
      default:
        return "-";
    }
  };

  const handlePageChange = (
    event: React.ChangeEvent<unknown>,
    value: number
  ) => {
    if (value !== page) {
      setPage(value);
    }
  };

  const handleCloseErrorPopup = () => {
    setError({ ...error, open: false });
  };

  const handleCloseError = (
    event: React.SyntheticEvent | Event,
    reason?: string
  ) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenError({
      open: false,
      message: "",
    });
  };

  const el = useMemo(() => {
    switch (storeRateContract.loading) {
      case true:
      case undefined:
        return <CustomSpinner size={"2rem"} />;
      case false:
        return (
          <>
            <NavigateBackButton
              label={"BACK TO RATE CONTRACTS"}
              navigateLink={`${PAGES_URL.ORDERMGR}/${PAGES_URL.RATE_CONTRACT_LIST}`}
            />
            <Box
              sx={{ mb: 2 }}
              display={"flex"}
              justifyContent={"space-between"}
              alignItems={"center"}
              className="headerBoxRC"
            >
              <Typography>{rateContract?.rateContractName} </Typography>
            </Box>

            <Box display={"flex"} gap={2}>
              <Card sx={{ flex: 1, pb: 2, borderRadius: 0, mb: "40px" }}>
                <Box
                  className="informationHeaderRFQ"
                  sx={{
                    backgroundColor: "#F7F7F7",
                    color: "#000000",
                    p: 2,
                  }}
                  display={"flex"}
                  justifyContent={"space-between"}
                  alignItems={"center"}
                >
                  <Box>
                    <Typography variant="body1" component="span">
                      Rate Contract ID - &nbsp;
                    </Typography>
                    <Typography variant="body2" component="span">
                      {rateContract?.rateContractCode}
                    </Typography>
                  </Box>
                </Box>
                <Box pl={"5px"}>
                  <Box display={"flex"} flexWrap="wrap">
                    {/* Fetching from constants */}
                    {RATE_CONTRACT_INFO?.map((details) => {
                      return (
                        <Box
                          width={details.width}
                          pl={"10px"}
                          py={"10px"}
                          key={"#RCDetail_" + details.label}
                          className="informationBodyRC"
                        >
                          <Typography variant="body1" sx={{ mb: 0.5 }}>
                            {details.label}
                          </Typography>
                          {}
                          <Typography variant="body2" sx={{ mb: 0.5 }}>
                            {renderSwitch(details)}
                          </Typography>
                        </Box>
                      );
                    })}
                  </Box>
                </Box>
              </Card>
            </Box>

            <Box display={"flex"} gap={2}>
              <Card sx={{ flex: 1, borderRadius: 0, mb: "40px" }}>
                <Box
                  className="informationHeaderRC"
                  sx={{
                    backgroundColor: "#F1F1F1",
                    color: "#000000",
                    p: 1,
                  }}
                  display={"flex"}
                  justifyContent={"space-between"}
                  alignItems={"center"}
                >
                  <Box>
                    <Typography variant="body1" component="span">
                      Orders
                    </Typography>
                  </Box>
                  <ButtonGroup aria-label="Basic button group">
                    <RoleBasedPermissionsGate roles={[PLATFORM_ROLES.SOCIETY]}>
                      <PermissionsGate
                        permissions={[PLATFORM_PERMISSIONS.ORDER_CREATE]}
                      >
                        <Button
                          variant="text"
                          sx={{
                            borderRadius: 0,
                            mr: 1,
                          }}
                          onClick={() =>
                            navigate(
                              `${PAGES_URL.ORDERMGR}/${PAGES_URL.CREATE_ORDER}`,
                              {
                                state: {
                                  contractId: rateContract?._id,
                                },
                              }
                            )
                          }
                        >
                          Add Order
                        </Button>
                      </PermissionsGate>
                    </RoleBasedPermissionsGate>
                  </ButtonGroup>
                </Box>
                {
                  <PermissionsGate
                    permissions={[PLATFORM_PERMISSIONS.ORDER_VIEW]}
                  >
                    <TableContainer sx={{ overflowX: "auto" }}>
                      <Table stickyHeader sx={{ minWidth: 1000 }}>
                        <TableHead>
                          <TableRow>
                            {/* Fetching from constants */}
                            {RC_ORDERS?.map((column) => (
                              <TableCell
                                key={column.id}
                                sx={{
                                  backgroundColor: "#F7F7F7",
                                  color: "#000000",
                                }}
                                width={`${column.length}%`}
                              >
                                {column.label}
                              </TableCell>
                            ))}
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {(!orders || orders?.length === 0) && (
                            <TableRow>
                              <TableCell
                                colSpan={RC_ORDERS?.length}
                                height={"90px"}
                              >
                                <Typography
                                  display={"flex"}
                                  justifyContent={"center"}
                                  alignItems={"center"}
                                >
                                  {" "}
                                  No Orders Added for Rate Contract{" "}
                                </Typography>
                              </TableCell>
                            </TableRow>
                          )}
                          {orders?.map((order: any) => {
                            return (
                              <TableRow key={order?._id}>
                                <TableCell>
                                  <Typography fontWeight={500} fontSize={14}>
                                    <PermissionsGate
                                      permissions={[
                                        PLATFORM_PERMISSIONS.QUOTE_VIEW,
                                      ]}
                                    >
                                      <Link
                                        to={`${PAGES_URL.ORDERMGR}/${PAGES_URL.ORDER_DETAILS}/${order._id}`}
                                      >
                                        <Typography
                                          sx={{
                                            fontFamily: "Inter",
                                            fontSize: "14px",
                                            fontWeight: "500",
                                            textTransform: "none",
                                            color: "#22438C",
                                          }}
                                        >
                                          {order?.referenceNumber &&
                                          order?.referenceNumber !== ""
                                            ? order?.referenceNumber
                                            : (order?.orderCode
                                                ? order?.orderCode.split("/")[5]
                                                : order?._id) ?? "-"}
                                        </Typography>
                                      </Link>
                                    </PermissionsGate>
                                  </Typography>
                                </TableCell>
                                <TableCell>
                                  <Typography fontWeight={500} fontSize={14}>
                                    {
                                      order?.fulfilledByPartyId?.details
                                        ?.groupName
                                    }
                                  </Typography>
                                </TableCell>
                                <TableCell>
                                  <Typography fontWeight={500} fontSize={14}>
                                    {order?.items?.length}
                                  </Typography>
                                </TableCell>
                                <TableCell>
                                  <Typography fontWeight={500} fontSize={14}>
                                    {order?.grandTotal?.toLocaleString(
                                      "en-IN",
                                      {
                                        maximumFractionDigits: 2,
                                        style: "currency",
                                        currency: "INR",
                                      }
                                    )}
                                  </Typography>
                                </TableCell>
                                <TableCell>
                                  <Typography fontWeight={500} fontSize={14}>
                                    {PO_STATUS[order?.statusId]}
                                  </Typography>
                                </TableCell>
                              </TableRow>
                            );
                          })}
                        </TableBody>
                      </Table>
                    </TableContainer>
                  </PermissionsGate>
                }
              </Card>
            </Box>

            <Box
              flex={1}
              display={"flex"}
              flexDirection={"column"}
              sx={{ mb: 2 }}
              className="tableDataRC"
            >
              <Card
                sx={{
                  flex: 1,
                  padding: 0,
                  borderRadius: 0,
                  overflow: "visible",
                }}
              >
                <TableContainer sx={{ overflowX: "auto" }}>
                  <Table sx={{ minWidth: 1000 }}>
                    <TableHead>
                      <TableRow>
                        {/* Fetching from constants */}
                        {RATE_CONTRACT_TABLE?.map((column) => (
                          <TableCell
                            key={column.id}
                            sx={{
                              backgroundColor: "#F7F7F7",
                              color: "#000000",
                            }}
                            width={column.colSpan}
                          >
                            {column.label}
                          </TableCell>
                        ))}
                        <TableCell sx={{ backgroundColor: "#F7F7F7" }} />
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {rateContract?.items?.length &&
                        rateContract.items
                          .slice(pageLimit * (page - 1), pageLimit * page)
                          .map((rateContractItems: any, ind: number) => {
                            return (
                              <TableRow
                                key={`itemRow${ind}`} // Make sure to add a unique key prop
                              >
                                {/* Fetching from constants */}
                                {RATE_CONTRACT_TABLE?.map((column: any) => {
                                  return (
                                    <TableCell
                                      key={`itemCell_${column.id}`} // Add a unique key for each TableCell
                                    >
                                      {rateContractItems[column.id] || "-"}
                                    </TableCell>
                                  );
                                })}
                              </TableRow>
                            );
                          })}
                      {/* Pagination Code goes here */}
                    </TableBody>
                  </Table>
                </TableContainer>
                <Stack direction={{ xs: "column", md: "row" }}>
                  <Box
                    className="paginationRC"
                    display={"flex"}
                    sx={{ width: { xs: "100%", md: "50%" }, justifyContent: { xs: "center", md: "flex-start" } }}
                  >
                    <Typography
                      variant="body1"
                      textAlign="center"
                      marginY="auto"
                      marginLeft={2}
                    >
                      Showing data {pageLimit * (page - 1) + 1} to{" "}
                      {pageLimit * page > rateContract?.items?.length
                        ? rateContract.items.length
                        : pageLimit * page}{" "}
                      from {rateContract?.items?.length}
                    </Typography>
                  </Box>
                  <Box
                    display={"flex"}
                    sx={{ justifyContent: { xs: "center", md: "flex-end" }, width: { xs: "100%", md: "50%" } }}
                  >
                    <Pagination
                      sx={{
                        padding: 4,
                      }}
                      count={
                        rateContract?.items
                          ? rateContract.items.length % pageLimit == 0
                            ? rateContract.items.length / pageLimit
                            : Math.floor(
                                rateContract.items.length / pageLimit
                              ) + 1
                          : 1
                      }
                      shape="rounded"
                      page={page}
                      onChange={handlePageChange}
                    />
                  </Box>
                </Stack>
              </Card>
            </Box>
          </>
        );
    }
  }, [storeRateContract.loading, rateContract, page]);

  return (
    <Box
      flex={1}
      display={"flex"}
      flexDirection={"column"}
      height={"100%"}
      margin={{ xs: 1, md: 4 }}
    >
      <Snackbar
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        open={openError.open}
        autoHideDuration={2000}
        onClose={handleCloseError}
        key={"errorDisplay"}
      >
        <Alert
          onClose={handleCloseError}
          severity="error"
          variant="filled"
          sx={{ width: "100%" }}
        >
          {openError.message}
        </Alert>
      </Snackbar>
      <ErrorPopup
        open={error.open}
        message={error.message}
        onClose={handleCloseErrorPopup}
      />
      {el}
    </Box>
  );
};

export default ViewRateContract;
